/**
 * @template T
 * @param {T[]} items
 * @param {number} count
 * @param {(item: T) => string|number} getKey
 * @returns {T[]}
 */
export function pickRandomUnique(items, count, getKey) {
  if (!Array.isArray(items) || items.length === 0 || count <= 0) return [];
  const shuffled = [...items].sort(() => Math.random() - 0.5);
  const seen = new Set();
  const out = [];
  for (const it of shuffled) {
    const k = String(getKey(it));
    if (seen.has(k)) continue;
    seen.add(k);
    out.push(it);
    if (out.length >= count) break;
  }
  return out;
}
